import C from 'axios';

const externalApi = C.create();

export async function cepViaCEP(cep) {
    const numCep = cep.replace(/[^0-9]/g, '');

    if (numCep.length !== 8) return;

    try {
        const response = await fetch(
            `https://viacep.com.br/ws/${numCep}/json`
        );

        if (!response.ok) {
            throw new Error('Não foi possível consultar o CEP');
        }

        const data = await response.json();

		if(data.erro == "true") {
			return null
		}

        return data;
    } catch (err) {
		throw new Error('O CEP informado não é válido ou é um CEP geral!')
    }
}

export async function cepBrasilApi(cep) {
	let numCep = cep.replace(/[^0-9]/g,'');

	if(numCep.length === 0) return;
	if(numCep.length != 8) return;
	
	try {
		const response = await fetch(
            `https://brasilapi.com.br/api/cep/v1/${numCep}`
        );

		if (!response.ok) {
           return null
        }

		const data = await response.json();

		return data;
	} catch (err) {
		return null
	}
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/util/BuscaCep.js